export default __webpack_public_path__ + "static/media/1.9546f02a.webp";